import { useState } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../services/api";

//AqzvthMuSpx% for jeremiah admin test user

function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    try {
      setIsSubmitting(true);
      await adminLogin({ email, password });
      navigate("/admin");
    } catch (submitError) {
      setError(submitError.message || "Login failed. Please check your credentials.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="mx-auto"
      style={{ maxWidth: "500px" }}
    >
      <Card className="glass-card text-light">
        <Card.Body>
          <h1 className="section-title mb-3">Admin Login</h1>
          <p className="text-muted-soft">Use your admin credentials to review submissions and publish approved resources.</p>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Button
              type="submit"
              className="cta-btn"
            >
              {isSubmitting ? "Signing In..." : "Login"}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </section>
  );
}

export default AdminLoginPage;
